import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles: ComponentStylesProps<boolean> = {
  modal: {
    textAlign: 'center',
    padding: '4rem 2.4rem',
    maxWidth: '65.6rem',
    maxHeight: '75vh',
  },
  icon: {
    marginBottom: '2.2rem',
  },
  modalTitle: (isSubtitleProvided) => ({
    font: isSubtitleProvided
      ? { size: '2.4rem', lineHeight: '3.2rem', weight: 700 }
      : { size: '2rem', lineHeight: '2.8rem', weight: 400 }, // show smaller title
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    margin: { bottom: '2rem' },
    padding: '0 1rem',
  }),
  contentText: {
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    lineHeight: '2.4rem',
    margin: '0 auto',
    color: colors.neutral[700],
    maxWidth: '60rem',
  },
  modalFooter: {
    display: 'flex',
    padding: '0 13%',
    marginTop: '4rem',
    justifyContent: 'center',
    '& button:not(:first-child)': {
      marginLeft: '1.6rem',
    },
  },
  actionButton: {
    padding: '0rem 2rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
